import { Media } from ".";
import Duration from "./Duration";
import Model from "./Model";
import IntervalCount from "@/interfaces/IntervalCount";

export default class Spot extends Model {
  static type = "spots";

  name!: string;
  url!: string;

  duration!: Duration;
  media!: Media;
  timeIntervals?: any[];
  spotType?: string;

  get type() {
    return Spot.type;
  }

  get intervalDetectionsCount() {
    if (this.media.isRadio) {
      return this.timeIntervals?.reduce(
        (count, b) => count + b.radioDetectionsCount,
        0
      );
    } else {
      return this.timeIntervals?.reduce(
        (count, b) => count + b.tvDetectionsCount,
        0
      );
    }
  }

  get grpCount() {
    if (this.media.isTV) {
      return this.timeIntervals?.reduce((count, b) => {
        if (isNaN(parseFloat(b.grpCount))) {
          return count;
        } else {
          return count + Number.parseFloat(b.grpCount);
        }
      }, 0);
    } else {
      return undefined;
    }
  }

  get hasVod(): boolean {
    return (
      this.timeIntervals?.some(
        (interval: IntervalCount) => interval.vodDetection
      ) ?? false
    );
  }
}
